module.exports = __webpack_public_path__ + "static/media/Kutuphanem.a0e55326.png";